import type { DosStatus } from "../../type/dos";

/** Warna cadangan jika status/warna kosong (sama dengan daftar lain). */
export const FALLBACK_STATUS_COLOR = "#6b7280";

const DARK_TEXT = "#111827";
const LIGHT_TEXT = "#ffffff";
const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const relativeLuminance = (hex: string) => {
  const full =
    hex.length === 4
      ? hex
          .slice(1)
          .split("")
          .map((c) => c + c)
          .join("")
      : hex.slice(1);

  const [r, g, b] = [0, 2, 4].map((i) => {
    const channel = parseInt(full.slice(i, i + 2), 16) / 255;
    return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

/** Rasio kontras WCAG antara dua warna hex. */
export const contrastRatio = (a: string, b: string) => {
  const [light, dark] = [relativeLuminance(a), relativeLuminance(b)].sort((x, y) => y - x);
  return (light + 0.05) / (dark + 0.05);
};

export const getBadgeColor = (color?: string | null) =>
  color && HEX.test(color.trim()) ? color.trim() : FALLBACK_STATUS_COLOR;

/**
 * Warna teks dengan kontras tertinggi di atas `background`
 * (mis. kuning Pending Approval -> teks gelap).
 */
export const getBadgeTextColor = (background: string) =>
  contrastRatio(background, DARK_TEXT) >= contrastRatio(background, LIGHT_TEXT)
    ? DARK_TEXT
    : LIGHT_TEXT;

export default function DosStatusBadge({ status }: { status: DosStatus | null }) {
  const background = getBadgeColor(status?.color);

  return (
    <span
      className="inline-block whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold"
      style={{ backgroundColor: background, color: getBadgeTextColor(background) }}>
      {status?.name ?? "-"}
    </span>
  );
}
